export default {
  appTitle: process.env.VUE_APP_TITLE,
  appVersion: process.env.VUE_APP_VERSION,
  baseUrl: process.env.VUE_APP_BASE_URL,
  userBaseUrl: "/live22",
  subAccessRoles: {
    account: "account",
    ticket: "ticket",
    bank: "bank",
    promotion: "promotion",
    report: "report",
    log: "log",
    system: "system"
  },
  pageParent: {
    setting: "system",
    account: "account",
    dashboard: "system",
    operator: "account",
    member: "account",
    subaccount: "account",
    socialaccount: "account",
    ticket: "ticket",
    bank: "bank",
    bankoperator: "bank",
    bankmember: "bank",
    promotion: "promotion",
    promopackage: "promotion",
    promoaccount: "promotion",
    promomember: "promotion",
    ibankaccount: "bank",
    adjustmemberlog: "log",
    issuebonuslog: "log",
    loginmemberlog: "log",
    dailystatement: "report",
    dailywinlose: "report",
    gameresultslots: "report",
    bankstatement: "report",
    transferlist: "report",
    bonusandadjustment: "report",
    promotionreport: "report",
    registeredmember: "report",
    depositedmember: "report",
    firstdeposit: "report",
    membernickname: "account",
    reportdownline: "report",
    downlineoperator: "report",
    dailystatementnest: "report",
    dailywinlosenest: "report",
    referredmember: "report",
  },
  accessRoles: {
    account: "account",
    dashboard: "dashboard",
    operator: "operator",
    member: "member",
    subaccount: "subaccount",
    ticket: "ticket",
    bank: "bank",
    bankoperator: "bankoperator",
    bankmember: "bankmember",
    firsttime: "firsttime",
    security: "security",
    setting: "setting",
    report: "report",
    promotion: "promotion",
    promopackage: "promopackage",
    promoaccount: "promoaccount",
    promomember: "promomember",
    ibankaccount: "ibankaccount",
    adjustmemberlog: "adjustmemberlog",
    issuebonuslog: "issuebonuslog",
    loginmemberlog: "loginmemberlog",
    dailystatement: "dailystatement",
    dailywinlose: "dailywinlose",
    gameresultslots: "gameresultslots",
    bankstatement: "bankstatement",
    socialaccount: "socialaccount",
    transferlist: "transferlist",
    bonusandadjustment: "bonusandadjustment",
    promotionreport: "promotionreport",
    registeredmember: "registeredmember",
    depositedmember: "depositedmember",
    firstdeposit: "firstdeposit",
    membernickname: "membernickname",
    monthlyrating: "monthlyrating",
    reportdownline: "reportdownline",
    downlineoperator: "downlineoperator",
    dailystatementnest: "dailystatementnest",
    dailywinlosenest: "dailywinlosenest",
    referredmember: "referredmember",
  },
  accessUrlPrefix: {
    operator: "/account",
    member: "/account",
    subaccount: "/account",
    ticket: "/ticket",
    bankoperator: "/bank",
    bankmember: "/bank",
    setting: "/system",
    report: "/report",
    promopackage: "/promotion",
    promoaccount: "/promotion",
    promomember: "/promotion",
    ibankaccount: "/ibank",
    adjustmemberlog: "/log",
    issuebonuslog: "/log",
    dailystatement: "/report",
    dailywinlose: "/report",
    gameresultslots: "/report",
    bankstatement: "/report",
    socialaccount: "/account",
    transferlist: "/report",
    bonusandadjustment: "/report",
    promotionreport: "/report",
    registeredmember: "/report",
    depositedmember: "/report",
    firstdeposit: "/report",
    membernickname: "/account",
    messageblast: "/message",
    downlineoperator: "/reportNest",
    dailystatementnest: "/reportNest",
    dailywinlosenest: "/reportNest",
    referredmember: "/report",
  },
  bankingList: [{ text: 'IBANK', value: 'IBANK'}, { text: 'MANUAL', value: 'MANUAL'}],
  gameResultDetailUrl: "https://result.apicashlive.com/result?bet_id=",
  masterAccessOptions: [
    'account', 'ticket', 'bank', 'promotion'
  ],
  operatorAccessOptions: {
    selfOperate: [
      'account', 'ticket', 'bank', 'promotion'
    ],
    notSelfOperate: [
      'account'
    ],
  },
  selfOperateBanPage : [
    'bank', 'ticket', 'promotion', 'socialaccount'
  ],
  masterPages: [
    'dashboard', 'subaccount', 'operator', 'ticket', 'setting', 'bankoperator', 'bankmember', 'socialaccount', 'bankstatement', 'transferlist', 'bonusandadjustment',
    'promopackage', 'promoaccount', 'promomember', 'ibankaccount', 'adjustmemberlog', 'issuebonuslog', 'loginmemberlog',
    'dailystatement', 'dailywinlose', 'gameresultslots', 'promotionreport', 'registeredmember', 'depositedmember', 'firstdeposit', 'membernickname', 'referredmember'],
  operatorPages: [
    'member', 'dashboard', 'subaccount', 'ticket', 'setting', 'bankoperator', 'bankmember', 'socialaccount', 'bankstatement', 'transferlist', 'bonusandadjustment',
    'promopackage', 'promoaccount', 'promomember', 'ibankaccount', 'adjustmemberlog', 'issuebonuslog', 'loginmemberlog',
    'dailystatement', 'dailywinlose', 'gameresultslots', 'promotionreport', 'registeredmember', 'depositedmember', 'firstdeposit', 'membernickname',
    'downlineoperator', 'dailystatementnest', 'dailywinlosenest', 'referredmember'],
  accNestAuthorizedUser: ['master1', 'master2', 'master3', 'master22'],
  loginUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountlogin";
  },
  addAccountUrl() {
    return this.baseUrl + this.userBaseUrl + "/addaccount";
  },
  addSecondaryUrl() {
    return this.baseUrl + this.userBaseUrl + "/addsecondary";
  },
  addSubUrl() {
    return this.baseUrl + this.userBaseUrl + "/addsub";
  },
  accountSubDetailUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountsubdetail";
  },
  authorityUpsertUrl() {
    return this.baseUrl + this.userBaseUrl + "/authorityupsert";
  },
  accountSubBlockUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountsubblock";
  },
  accountSubUnblockUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountsubunblock";
  },
  securityValidateUrl() {
    return this.baseUrl + this.userBaseUrl + "/securityvalidate";
  },
  securityUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/securityupdate";
  },
  securityDisableUrl() {
    return this.baseUrl + this.userBaseUrl + "/securitydisable";
  },
  passwordUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/passwordupdate";
  },
  memberListUrl() {
    return this.baseUrl + this.userBaseUrl + "/memberlist";
  },
  accountListUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountlist";
  },
  accountSubListUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountsublist";
  },
  accountAgentDetailUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountagentdetail";
  },
  accountSetupUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountsetup";
  },
  statusUpdateMemberUrl() {
    return this.baseUrl + this.userBaseUrl + "/statusupdatemember";
  },
  statusUpdateOperatorUrl() {
    return this.baseUrl + this.userBaseUrl + "/statusupdateoperator";
  },
  updateAccountUrl() {
    return this.baseUrl + this.userBaseUrl + "/updateaccount";
  },
  updateMemberUrl() {
    return this.baseUrl + this.userBaseUrl + "/updatemember";
  },
  ticketListUrl() {
    return this.baseUrl + this.userBaseUrl + "/ticketlist";
  },
  ticketDetailUrl() {
    return this.baseUrl + this.userBaseUrl + "/ticketdetail";
  },
  ticketApproveDepositUrl() {
    return this.baseUrl + this.userBaseUrl + "/ticketapprovedeposit";
  },
  ticketApproveWithdrawalUrl() {
    return this.baseUrl + this.userBaseUrl + "/ticketapprovewithdrawal";
  },
  ticketRejectUrl() {
    return this.baseUrl + this.userBaseUrl + "/ticketreject";
  },
  ticketApproveRejectUrl() {
    return this.baseUrl + this.userBaseUrl + "/ticketapprovereject";
  },
  ticketAuditUrl() {
    return this.baseUrl + this.userBaseUrl + "/ticketaudit";
  },
  updateOperationModeUrl() {
    return this.baseUrl + this.userBaseUrl + "/updateoperationmode";
  },
  bankAccountAddUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankaccountadd";
  },
  bankAccountListUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankaccountlist";
  },
  bankAccountStatusUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankaccountstatusupdate";
  },
  bankAccountUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankaccountupdate";
  },
  bankLookupUrl() {
    return this.baseUrl + this.userBaseUrl + "/banklookup";
  },
  bankMemberStatusUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankmemberstatusupdate";
  },
  bankMemberUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankmemberupdate";
  },
  bankThresholdResetUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankthresholdreset";
  },
  bankMemberListUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankmemberlist";
  },
  bankSettingUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/banksettingupdate";
  },
  bankSettingListUrl() {
    return this.baseUrl + this.userBaseUrl + "/banksettinglist";
  },
  bankTransferUrl() {
    return this.baseUrl + this.userBaseUrl + "/banktransfer";
  },
  adjustMemberUrl() {
    return this.baseUrl + this.userBaseUrl + "/adjustmember";
  },
  adjustBankUrl() {
    return this.baseUrl + this.userBaseUrl + "/adjustbank";
  },
  ibankAccountListUrl() {
    return this.baseUrl + this.userBaseUrl + "/ibankaccountlist";
  },
  ibankListUrl() {
    return this.baseUrl + this.userBaseUrl + "/ibankaccountlist";
  },
  ibankAccountStatusUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/ibankaccountstatusupdate";
  },
  ibankAccountUpsertUrl() {
    return this.baseUrl + this.userBaseUrl + "/ibankaccountupsert";
  },
  promotionListUrl() {
    return this.baseUrl + this.userBaseUrl + "/promotionlist";
  },
  promoAccountListUrl() {
    return this.baseUrl + this.userBaseUrl + "/promoaccountlist";
  },
  promoPackageDownloadUrl() {
    return this.baseUrl + this.userBaseUrl + "/promopackagedownload";
  },
  promoPackageListUrl() {
    return this.baseUrl + this.userBaseUrl + "/promopackagelist";
  },
  promoPackageStatusUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/promopackagestatusupdate";
  },
  promoMemberKnockOffUrl() {
    return this.baseUrl + this.userBaseUrl + "/promomemberknockoff";
  },
  promoMemberAddUrl() {
    return this.baseUrl + this.userBaseUrl + "/promomemberadd";
  },
  promoMemberListUrl() {
    return this.baseUrl + this.userBaseUrl + "/promomemberlist";
  },
  issueBonusUrl() {
    return this.baseUrl + this.userBaseUrl + "/issuebonus";
  },
  issueBonusPromoUrl() {
    return this.baseUrl + this.userBaseUrl + "/issuebonuspromo";
  },
  issueBonusListUrl() {
    return this.baseUrl + this.userBaseUrl + "/issuebonuslist";
  },
  adjustMemberListUrl() {
    return this.baseUrl + this.userBaseUrl + "/adjustmemberlist";
  },
  dailyStatementUrl() {
    return this.baseUrl + this.userBaseUrl + "/dailystatement";
  },
  dailyWinLoseUrl() {
    return this.baseUrl + this.userBaseUrl + "/dailywinlose";
  },
  gameResultSlotsUrl() {
    return this.baseUrl + this.userBaseUrl + "/gameresultslots";
  },
  accountSocialUpdateUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountsocialupdate";
  },
  accountSocialListUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountsociallist";
  },
  auditLoginMemberUrl() {
    return this.baseUrl + this.userBaseUrl + "/auditloginmember";
  },
  bankStatementOperatorUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankstatementoperator";
  },
  transferListUrl() {
    return this.baseUrl + this.userBaseUrl + "/transferlist";
  },
  accountUnblockMemberUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountunblockmember";
  },
  accountUnblockOperatorUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountunblockoperator";
  },
  monthlySummaryUrl() {
    return this.baseUrl + this.userBaseUrl + "/monthlysummary";
  },
  monthlyActivePlayerUrl() {
    return this.baseUrl + this.userBaseUrl + "/monthlyactiveplayer";
  },
  memberCountUrl() {
    return this.baseUrl + this.userBaseUrl + "/membercount";
  },
  monthlyTopWinnerUrl() {
    return this.baseUrl + this.userBaseUrl + "/monthlytopwinner";
  },
  monthlyTopLoserUrl() {
    return this.baseUrl + this.userBaseUrl + "/monthlytoploser";
  },
  monthlySummaryMemberUrl() {
    return this.baseUrl + this.userBaseUrl + "/monthlysummarymember";
  },
  last10LoginUrl() {
    return this.baseUrl + this.userBaseUrl + "/last10login";
  },
  last10DepositWithdrawalUrl() {
    return this.baseUrl + this.userBaseUrl + "/last10depositwithdrawal";
  },
  accountMemberDetailUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountmemberdetail";
  },
  passwordResetUrl() {
    return this.baseUrl + this.userBaseUrl + "/passwordreset";
  },
  passwordResetMemberUrl() {
    return this.baseUrl + this.userBaseUrl + "/passwordresetmember";
  },
  passwordResetSubUrl() {
    return this.baseUrl + this.userBaseUrl + "/passwordresetsub";
  },
  promoPackageLookupUrl() {
    return this.baseUrl + this.userBaseUrl + "/promopackagelookup";
  },
  promotionReportUrl() {
    return this.baseUrl + this.userBaseUrl + "/promotionreport";
  },
  registeredMemberUrl() {
    return this.baseUrl + this.userBaseUrl + "/registeredmember";
  },
  depositedMemberUrl() {
    return this.baseUrl + this.userBaseUrl + "/depositedmember";
  },
  promoMemberAddFBUrl() {
    return this.baseUrl + this.userBaseUrl + "/promomemberaddfb";
  },
  promoPackageLookupFBUrl() {
    return this.baseUrl + this.userBaseUrl + "/promopackagelookupfb";
  },
  firstDepositUrl() {
    return this.baseUrl + this.userBaseUrl + "/firstdeposit";
  },
  memberNicknameLookupUrl() {
    return this.baseUrl + this.userBaseUrl + "/membernicknamelookup";
  },
  accountNestListUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountnestlist";
  },
  accountNestUpsertUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountnestupsert";
  },
  accountNestListDownlineUrl() {
    return this.baseUrl + this.userBaseUrl + "/accountnestlistdownline";
  },
  dailyStatementNestUrl() {
    return this.baseUrl + this.userBaseUrl + "/dailystatementnest";
  },
  dailyWinLoseNestUrl() {
    return this.baseUrl + this.userBaseUrl + "/dailywinlosenest";
  },
  issueTournamentUrl() {
    return this.baseUrl + this.userBaseUrl + "/issuetournament";
  },
  checkMemberFreeSpinUrl() {
    return this.baseUrl + this.userBaseUrl + "/checkmemberfreespin";
  },
  bankAccountWithdrawalListUrl() {
    return this.baseUrl + this.userBaseUrl + "/bankaccountwithdrawallist";
  },
  tacGetUrl() {
    return this.baseUrl + this.userBaseUrl + "/tacget";
  },
  referredMemberUrl() {
    return this.baseUrl + this.userBaseUrl + "/referredmember";
  },
  bankTacGetUrl() {
    return this.baseUrl + this.userBaseUrl + "/banktacget";
  },
};
